import { useEffect, useState } from 'react'

import apiRequest from '../lib/http'
import { getOfficesPromise, setOfficesPromise } from '../lib/officeVisibilityCache'

const FULL = 'FULL'
const NO_OFFICES = []

const loadOffices = () => {
  if (!getOfficesPromise()) {
    setOfficesPromise(
      apiRequest.get('/affiliates/my-offices')
        .then(response => response.data.data || [])
        .catch(() => [])
    )
  }

  return getOfficesPromise()
}

export const resolveActiveOffice = (offices, activeOfficeId) => (
  offices.find(office => office._id === activeOfficeId)
  || (offices.length === 1 ? offices[0] : null)
)

export const useOfficeVisibility = (user) => {
  const [offices, setOffices] = useState(null)
  const role = user?.role
  const userId = user?._id
  const isAffiliate = role === 'affiliate'

  useEffect(() => {
    if (!role) return undefined

    if (!isAffiliate) {
      setOffices(NO_OFFICES)
      return undefined
    }

    let current = true
    loadOffices().then((list) => {
      if (current) setOffices(list)
    })

    return () => {
      current = false
    }
  }, [role, userId, isAffiliate])

  if (!user) return { offices: NO_OFFICES, level: FULL, resolved: false }
  if (!isAffiliate) return { offices: NO_OFFICES, level: FULL, resolved: true }
  if (offices === null) return { offices: NO_OFFICES, level: FULL, resolved: false }

  const activeOffice = resolveActiveOffice(offices, localStorage.getItem('activeOfficeId'))

  const level = activeOffice?.isOwner ? FULL : (activeOffice?.dashboardVisibility || FULL)

  return { offices, level, resolved: true }
}
